import { network } from 'services/network';

export const deleteUserGroup = (params) => {
    return network.post('admin/bo/deleteUserGroup', params).then((response) => response.data);
};
